import React, { createContext, useContext, useEffect, useState } from "react";
import { useGetIsAdmin } from "../api/hooks/useRiskThemes";
import { useTenant } from "./tenantContext";

const AdminContext = createContext<boolean | null>(null);

export const AdminProvider = ({ children }: { children: React.ReactNode }) => {
  const { selectedTenant } = useTenant();

  const { data: dataIsAdmin, refetch } = useGetIsAdmin(!!selectedTenant);
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    if (dataIsAdmin !== undefined) {
      setIsAdmin(dataIsAdmin);
    }
  }, [dataIsAdmin]);

  useEffect(() => {
    if (selectedTenant !== null) {
      refetch();
    }
  }, [selectedTenant]);

  return (
    <AdminContext.Provider value={isAdmin}>{children}</AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
